import { gql } from '../util/fetchGql';
import Awards, { AWARDS_PRODUCT_FRAGMENT } from './Awards';
import Text, { TEXT_PRODUCT_FRAGMENT } from './Text';
import Technical, { TECHNICAL_PRODUCT_FRAGMENT } from './Technical';

export const PRODUCT_CONTENT_FRAGMENT = gql`
	fragment ProductContent on MatrixBlockInterface {
		key: id
		typeHandle
		...AwardsProduct
		...TextProduct
		...TechnicalProduct
	}
	${AWARDS_PRODUCT_FRAGMENT}
	${TEXT_PRODUCT_FRAGMENT}
	${TECHNICAL_PRODUCT_FRAGMENT}
`;

export default function ProductContent ({ blocks, accent }) {
	return (blocks ?? []).map(block => {
		switch (block.typeHandle) {
			case 'awards':
				return <Awards {...block} />;
			case 'text':
				return <Text {...block} />;
			case 'technical':
				return <Technical accent={accent} {...block} />;
			default:
				return block.typeHandle;
		}
	});
}
